import { LIST_ROLES } from '../actions/rolesActions';
import { RoleType } from 'src/types';

export type RoleListType = {
  items: Array<RoleType>;
};

export type RolesReducerActionType = {
  type: string;
  payload: Array<RoleType>;
};

const defaultState = {
  items: [],
};

const rolesReducer = (state = defaultState, action: RolesReducerActionType) => {
  switch (action.type) {
    case LIST_ROLES:
      return {
        items: action.payload,
      };
    default:
      return state;
  }
};

export default rolesReducer;
